import React from "react";
import "./ServicesSection.css";
import img1 from "../assets3/top_load_washing_machine.avif";
import img2 from "../assets3/Front-Load Machine Repair.jpg";
import img3 from "../assets3/Semi Automatic Washing Machine Repair.jpeg";

// Dedicated Washing Machine SVG Icon
const WasherIcon = () => (
  <svg stroke="currentColor" fill="none" strokeWidth="2" viewBox="0 0 24 24" height="2em" width="2em" xmlns="http://www.w3.org/2000/svg">
    <rect x="5" y="3" width="14" height="18" rx="2" />
    <circle cx="12" cy="13" r="4" />
    <circle cx="9" cy="6" r="1" />
    <circle cx="12" cy="6" r="1" />
    <line x1="5" y1="9" x2="19" y2="9" />
  </svg>
);

const ServicesSection = () => {
  // Encoded WhatsApp text strings for specific washing machine styles
  const topLoadMessage = encodeURIComponent("Hello Jay Ambe Washing Machine Services, I want to book a Top-Load Washing Machine Repair appointment.");
  const frontLoadMessage = encodeURIComponent("Hello Jay Ambe Washing Machine Services, I want to book a Front-Load Washing Machine Repair appointment.");
  const semiAutoMessage = encodeURIComponent("Hello Jay Ambe Washing Machine Services, I want to book a Semi-Automatic Washing Machine Repair appointment.");

  return (
    <section className="eawm-services-section">
      <div className="eawm-services-container">
        
        {/* Section Header */}
        <div className="eawm-section-header">
          <span className="eawm-sub-tag">OUR SERVICES</span>
          <h2 className="eawm-main-heading">
            Expert Repair Solutions for All Washing Machine Types
          </h2>
        </div>

        {/* Services Cards Grid */}
        <div className="eawm-cards-grid">
          
          {/* Card 1: Top-Load Repair */}
          <div className="eawm-service-card eawm-topload-card">
            <div className="eawm-card-image-wrapper">
              <img 
                src={img1}
                alt="Top-Load Washing Machine Repair" 
                className="eawm-card-bg"
              />
            </div>
            <div className="eawm-card-floating-content">
              <div className="eawm-card-icon">
                <WasherIcon />
              </div>
              <h3>Top-Load Machine Repair</h3>
              <p>
                Professional diagnostic and repair services for all fully automatic 
                top-loading machines. We fix agitator errors, water fills, sensor problems, 
                and spinning faults effectively at your doorstep.
              </p>
              <a 
                href={`https://wa.me/917317596984?text=${topLoadMessage}`}
                target="_blank" 
                rel="noreferrer" 
                className="eawm-book-link"
              >
                BOOK NOW!
              </a>
            </div>
          </div>

          {/* Card 2: Front-Load Repair */}
          <div className="eawm-service-card eawm-frontload-card">
            <div className="eawm-card-image-wrapper">
              <img 
                src={img2} 
                alt="Front-Load Washing Machine Repair" 
                className="eawm-card-bg"
              />
            </div>
            <div className="eawm-card-floating-content">
              <div className="eawm-card-icon">
                <WasherIcon />
              </div>
              <h3>Front-Load Machine Repair</h3>
              <p>
                Specialized solutions for premium front-loading washers. Expert management 
                of rubber gasket leaks, drum balancing, door lock errors, and control board 
                (PCB) troubleshooting for all major brands.
              </p>
              <a 
                href={`https://wa.me/917317596984?text=${frontLoadMessage}`}
                target="_blank" 
                rel="noreferrer" 
                className="eawm-book-link"
              >
                BOOK NOW!
              </a>
            </div>
          </div>

          {/* Card 3: Semi-Automatic Repair */}
          <div className="eawm-service-card eawm-semiauto-card">
            <div className="eawm-card-image-wrapper">
              <img 
                src={img3}
                alt="Semi-Automatic Washing Machine Repair" 
                className="eawm-card-bg"
              />
            </div>
            <div className="eawm-card-floating-content">
              <div className="eawm-card-icon">
                <WasherIcon />
              </div>
              <h3>Semi-Automatic Repair</h3>
              <p>
                Affordable, quick repairs for twin-tub semi-automatic washers. 
                We replace faulty spin motors, wash timers, broken selector knobs, and 
                resolve clogged drain pipe systems on-site.
              </p>
              <a 
                href={`https://wa.me/917317596984?text=${semiAutoMessage}`}
                target="_blank" 
                rel="noreferrer" 
                className="eawm-book-link"
              >
                BOOK NOW!
              </a>
            </div>
          </div>

        </div>

      </div>
    </section>
  );
};

export default ServicesSection;